import { AbstractListApi } from '../abstract/api';

export default class Api extends AbstractListApi {
  constructor({ base }) {
    super({ base, root: 'devices', listPath: '', authenticated: true });
  }
}
